import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "selected-tag"
};
const _hoisted_2 = {
  class: "prop-image-container"
};
const _hoisted_3 = {
  key: 0,
  class: "prop-tags"
};
const _hoisted_4 = {
  key: 1,
  class: "price"
};
const _hoisted_5 = {
  key: 2,
  class: "source"
};
const _hoisted_6 = {
  class: "prop-content"
};
const _hoisted_7 = {
  class: "title"
};
const _hoisted_8 = {
  key: 0,
  class: "prop-times"
};
const _hoisted_9 = {
  key: 1,
  class: "disabled-prop"
};
const _hoisted_10 = {
  key: 2,
  class: "transaction-prop"
};
const _hoisted_11 = {
  class: "desc"
};
import { Select } from '@element-plus/icons-vue';
import { propsDefaultImage } from '@/tools/utils';
export default {
  __name: 'PropsCard',
  props: {
    data: {
      type: Object,
      required: true
    },
    pocketMode: {
      type: Boolean,
      default: false,
      required: false
    },
    isSelected: {
      type: Boolean,
      default: false,
      required: false
    }
  },

  setup(__props) {
    return (_ctx, _cache) => {
      const _component_el_icon = _resolveComponent("el-icon");

      const _component_el_image = _resolveComponent("el-image");

      const _component_el_tag = _resolveComponent("el-tag");

      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["prop-container", __props.isSelected ? 'is-selected' : ''])
      }, [__props.isSelected ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_icon, {
        size: 18
      }, {
        default: _withCtx(() => [_createVNode(_unref(Select))]),
        _: 1
      })])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_2, [_createVNode(_component_el_image, {
        class: "prop-image",
        src: __props.data.image && __props.data.image.length > 0 ? __props.data.image : _unref(propsDefaultImage),
        draggable: "false"
      }, null, 8, ["src"]), __props.data?.type && __props.data?.tag ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createVNode(_component_el_tag, {
        class: _normalizeClass(`rare-${__props.data.rare_level}`)
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(__props.data.rare_desc), 1)]),
        _: 1
      }, 8, ["class"]), _createVNode(_component_el_tag, null, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(__props.data.type.desc), 1)]),
        _: 1
      }), _createVNode(_component_el_tag, null, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(__props.data.tag.desc), 1)]),
        _: 1
      })])) : _createCommentVNode("", true), !__props.pocketMode ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_cache[0] || (_cache[0] = _createElementVNode("span", {
        style: {
          "font-size": "0.8rem"
        }
      }, "售 ", -1)), _createTextVNode(" " + _toDisplayString(parseFloat(__props.data.price).toFixed(1)), 1)])) : __props.data?.source ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(__props.data.source && __props.data.source.length !== 0 ? __props.data.source : '雾海'), 1)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_6, [_createElementVNode("text", _hoisted_7, [_createTextVNode(_toDisplayString(__props.data.name) + " ", 1), __props.data?.type?.is_stackable ? (_openBlock(), _createElementBlock("span", _hoisted_8, "  x " + _toDisplayString(__props.data.times), 1)) : _createCommentVNode("", true), __props.pocketMode && !__props.data.enable ? (_openBlock(), _createElementBlock("span", _hoisted_9, " 【残损】 ")) : _createCommentVNode("", true), __props.pocketMode && __props.data.in_transaction ? (_openBlock(), _createElementBlock("span", _hoisted_10, " 【贸易中】 ")) : _createCommentVNode("", true)]), _createElementVNode("text", _hoisted_11, _toDisplayString(__props.pocketMode ? __props.data.function_desc : __props.data.appearance_desc), 1)])], 2);
    };
  }

};